import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  transactions: {
    data: [],
    loading: false,
    error: null,
    count: 0,
  },
  clients: {
    data: [],
    loading: false,
    error: null,
    count: 0,
  },
  associate: {
    data: [],
    loading: false,
    error: null,
  },
};

const transactionsReducer = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.TRANSACTION_DETAILS_LOADING:
    case actionTypes.TRANSACTION_DETAILS_V2_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.TRANSACTION_DETAILS_ERROR:
    case actionTypes.TRANSACTION_DETAILS_V2_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.TRANSACTION_DETAILS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
        error: null,
      };
    case actionTypes.TRANSACTION_DETAILS_V2_SUCCESS:
      return {
        ...state,
        count: payload?.count,
        data: [...state.data, ...payload?.items],
        loading: false,
        error: null,
      };
    case actionTypes.RESET_TRANSACTION_DETAILS:
    case actionTypes.RESET_TRANSACTION_DETAILS_V2:
    case actionTypes.RESET_ASSOCIATE_SALES:
      return {
        ...INITIAL_STATE.transactions,
        loading: payload?.keepLoadingState ? state.loading : false,
      };
    default:
      return state;
  }
};

const clientsReducer = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.PERF_CLIENT_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.PERF_CLIENT_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.PERF_CLIENT_DETAILS_SUCCESS:
      return {
        ...state,
        count: payload?.count,
        data: [...state.data, ...payload?.items],
        loading: false,
        error: null,
      };
    case actionTypes.PERF_RESET_CLIENT_DETAILS:
    case actionTypes.RESET_ASSOCIATE_SALES:
      return {
        ...INITIAL_STATE.transactions,
        loading: payload?.keepLoadingState ? state.loading : false,
      };
    default:
      return state;
  }
};

const associateReducer = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.PERF_ASSOCIATE_DATA_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.PERF_ASSOCIATE_DATA_SUCCESS:
      return {
        ...state,
        data: [...state.data, payload],
        loading: false,
        error: null,
      };
    case actionTypes.PERF_ASSOCIATE_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.PERF_RESET_ASSOCIATE_DATA:
      return {
        ...INITIAL_STATE.associate,
        loading: payload?.keepLoadingState ? state.loading : false,
      };
    default:
      return state;
  }
};

const associateSales = (state = INITIAL_STATE, action) => ({
  ...state,
  transactions: { ...transactionsReducer(state.transactions, action) },
  clients: { ...clientsReducer(state.clients, action) },
  associate: { ...associateReducer(state.associate, action) },
});

export default associateSales;
